import React from 'react';
import Chat from '../../chat/Chat'

interface PreviewProps {
    selectedConversation: { conversation_id: string, title: string, messages: any[], source?: 'chat' | 'ledger_agent' } | null;
    selectedId?: string | null;
    readOnly?: boolean;
    animatingOut?: boolean;
}

const Preview: React.FC<PreviewProps> = ({ selectedConversation, selectedId, readOnly, animatingOut }) => {
    const continuationContext = React.useMemo(() => {
        if (!selectedConversation || selectedConversation.source !== 'ledger_agent') return undefined;
        const recentMessages = (selectedConversation.messages || []).slice(-8);
        const transcript = recentMessages
            .map((message) => {
                const role = message.role === 'human' ? 'User' : 'Assistant';
                const content = String(message.content || '').replace(/\s+/g, ' ').trim().slice(0, 300);
                return content ? `${role}: ${content}` : null;
            })
            .filter(Boolean)
            .join('\n');
        return transcript || undefined;
    }, [selectedConversation]);

    // We stay in the "Chat UI" mode if we have data OR if we are still sliding away
    const showChatUI = !!selectedConversation || animatingOut;

    return (
        <div className="h-full w-full relative bg-white">
            {selectedConversation ? (
                <div className="h-full w-full bg-white">
                    <Chat
                        messages={selectedConversation.messages || []}
                        conversationId={selectedConversation.conversation_id || ''}
                        mode={'history'}
                        readOnly={readOnly}
                        historySource={selectedConversation.source}
                        continuationContext={continuationContext}
                    />
                </div>
            ) : animatingOut ? (
                /* IMPORTANT: During animatingOut, selectedConversation becomes null.
                   If Chat depends on that object, it disappears, causing a white flash.
                   We keep a placeholder here to prevent the sudden "emptiness".
                */
                <div className="h-full w-full bg-white" />
            ) : selectedId ? (
                /* This is the state where we have clicked but data hasn't arrived */
                <div className="h-full w-full flex items-center justify-center bg-white z-50">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div>
                </div>
            ) : (
                <div className="h-full w-full flex items-center justify-center bg-gray-50">
                    <p className="text-gray-500 font-medium px-4 text-center">
                        Select a conversation to preview
                    </p>
                </div>
            )}
        </div>
    );
};

export default Preview;
